import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _merge from "lodash/merge";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import { useState, useEffect, useCallback } from "react";
import { useConfig } from "./config";
import useChannel from "./channel";

var useRunConnection = function useRunConnection(org, runId) {
  var _useState = useState(),
      run = _useState[0],
      setRun = _useState[1];

  var _useConfig = useConfig(),
      url = _useConfig.url,
      token = _useConfig.token;

  var channel = useChannel(url + "/" + org + "/runs/" + runId + "/channel", token);
  var onRunStatus = useCallback(function (newRun) {
    setRun(function (existingRun) {
      return _merge({}, existingRun, newRun);
    });
  }, []);
  useEffect(function () {
    if (channel.connection) {
      channel.connection.on("RunStatus", onRunStatus);
    }

    return function () {
      if (channel.connection) {
        channel.connection.off("RunStatus", onRunStatus);
      }
    };
  }, [channel.connection, onRunStatus]);
  return _objectSpread({
    run: run
  }, channel);
};

export default useRunConnection;